export const DAY_NAMES: {[key: string]: string} = {
  Monday: $localize `:@@DayNameMonday:Monday`,
  Tuesday: $localize `:@@DayNameTuesday:Tuesday`,
  Wednesday: $localize `:@@DayNameWednesday:Wednesday`,
  Thursday: $localize `:@@DayNameThursday:Thursday`,
  Friday: $localize `:@@DayNameFriday:Friday`,
  Saturday: $localize `:@@DayNameSaturday:Saturday`,
  Sunday: $localize `:@@DayNameSunday:Sunday`,
}

export const DayNamesList: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
